import { scribeTokens as ui } from '../../components/scribe/tokens';
import React, { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import TemplateView from '../Settings/Template/TemplateView';
import { hasReportContent } from '../../utils/reportContent';
import ConsultationReportHeader, { useReportTools } from './ConsultationReportHeader';

// `idleStatus` and `showEmptyNotice` let Write's blank typed document (not yet
// saved, intentionally empty) reuse this editor without report-specific copy.
export default function WriteReportDocument({ item, onDirtyChange, onRename, onDownload, share, hideTitle = false, idleStatus, showEmptyNotice = true, ...editorProps }) {
  const [dirty, setDirty] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  const { tools, editorTools } = useReportTools();
  const editable = !item.isLocked;
  const changeDirty = value => { setDirty(value); if (!value) setSaveFailed(false); onDirtyChange(item.id, value); };
  useEffect(() => () => onDirtyChange(item.id, false), [item.id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!dirty) return undefined;
    const warn = event => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
  return <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', '& .ProseMirror': { ...ui.typography.content, fontFamily: ui.fontFamily } }}>
    <ConsultationReportHeader hideTitle={hideTitle} item={item} onRename={onRename} onDownload={onDownload} share={share}
      tools={{ ...tools, onToggleFormat: editable ? tools.onToggleFormat : undefined, onSaveTemplate: editable ? tools.onSaveTemplate : undefined, canCheckSources: Boolean(editorProps.onCheckSources) }}
      status={saveFailed ? 'Not saved — edit to retry' : dirty ? 'Saving changes…' : item.isLocked ? 'Locked report' : idleStatus || 'Changes saved'} />
    {showEmptyNotice && !hasReportContent(item.originalData?.content) && <Alert severity="info" sx={{ mb: 2 }}>This report has no saved content. Select sources and generate a new report, or edit this document.</Alert>}
    <TemplateView {...editorProps} reportId={item.id} reportContent={item.originalData?.content || ''} reportTitle={item.title}
      view="report" edit={editable} reportTools={editorTools} onDirtyChange={changeDirty} onSaveError={() => setSaveFailed(true)} />
  </Box>;
}
